import React from "react";

const Pencil = props => (
  <svg viewBox="0 0 15 14" fill="none" {...props}>
    <path
      d="M14.11 3.894c.52-.52.52-1.367 0-1.86L12.47.395c-.493-.52-1.34-.52-1.86 0L9.353 1.652c-.11.11-.11.328 0 .465l3.035 3.035c.136.11.355.11.464 0l1.258-1.258zM8.286 2.72l-7.191 7.19-.574 3.31a.65.65 0 00.765.765l3.309-.574 7.191-7.191c.137-.11.137-.329 0-.465L8.751 2.719c-.137-.11-.355-.11-.465 0zm-5.36 8.859H4.24v1.012l-1.777.3-.848-.847.301-1.778h1.012v1.313z"
      fill="currentColor"
    />
  </svg>
);

export default Pencil;
